import { ColorProps } from 'types';

// ==============================|| DEFAULT THEME COLORS ||============================== //

const defaultColor: ColorProps = {
  // paper & background
  paper: '#ffffff',

  // primary (Trans-Uni orange)
  primaryLight: '#fff1ea',
  primary200: '#fdb48d',
  primaryMain: '#f26522',
  primaryDark: '#ca3c08',
  primary800: '#8f2b06',

  // secondary (Trans-Uni neutral gray / ink)
  secondaryLight: '#f6f6f6',
  secondary200: '#ced0d4',
  secondaryMain: '#666666',
  secondaryDark: '#1f1f25',
  secondary800: '#010001',

  // success
  successLight: '#dff6e8',
  success200: '#9be0b3',
  successMain: '#3eb75e',
  successDark: '#258641',

  // error
  errorLight: '#ffe5e5',
  errorMain: '#ff0003',
  errorDark: '#b80002',

  // orange
  orangeLight: '#fff1ea',
  orangeMain: '#f26522',
  orangeDark: '#ca3c08',

  // warning
  warningLight: '#fff3e8',
  warningMain: '#ff8f3c',
  warningDark: '#c75f05',

  // grey
  grey50: '#fafafb',
  grey100: '#f6f6f6',
  grey200: '#e6e6e6',
  grey300: '#ced0d4',
  grey500: '#757575',
  grey600: '#666666',
  grey700: '#1d1d24',
  grey900: '#1f1f25',

  // ==============================|| DARK THEME VARIANTS ||============================== //

  // paper & background
  darkPaper: '#010001',
  darkBackground: '#18181b',

  // dark 800 & 900
  darkLevel1: '#1f1f25',
  darkLevel2: '#24242a',

  // text variants
  darkTextTitle: '#ffffff',
  darkTextPrimary: '#e4e6ea',
  darkTextSecondary: '#c6c9d8',

  // primary dark (orange on dark backgrounds)
  darkPrimaryLight: '#fff1ea',
  darkPrimaryMain: '#f26522',
  darkPrimaryDark: '#ca3c08',
  darkPrimary200: '#fdb48d',
  darkPrimary800: '#8f2b06',

  // secondary dark (neutral gray)
  darkSecondaryLight: '#f6f6f6',
  darkSecondaryMain: '#c6c9d8',
  darkSecondaryDark: '#ffffff',
  darkSecondary200: '#666666',
  darkSecondary800: '#1f1f25'
};

export default defaultColor;
